import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as Endpoints from "../../entities/Endpoints";
import { updateRecipeApi, deleteRecipeByIdApi } from "../../api/updateStandardRecipeApi";

// ✅ UPDATE Recipe Thunk
export const updateRecipeThunk = createAsyncThunk(
  Endpoints.UPDATE_STANDARD_RECIPES,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateRecipeApi(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Something went wrong while updating recipe.");
    }
  }
);

// ✅ DELETE Recipe Thunk
export const deleteRecipeThunk = createAsyncThunk(
  Endpoints.DELETE_STANDARD_RECIPE_BY_ID,
  async (recipeId, { rejectWithValue }) => {
    try {
      const response = await deleteRecipeByIdApi(recipeId);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Something went wrong while deleting recipe.");
    }
  }
);

const initialState = {
  loading: false,
  success: false,
  error: null,
  deleteSuccess: false,
};

const recipeSlice = createSlice({
  name: "recipe",
  initialState,
  reducers: {
    resetRecipeState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.deleteSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🟩 UPDATE Recipe
      .addCase(updateRecipeThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateRecipeThunk.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(updateRecipeThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      // 🟥 DELETE Recipe
      .addCase(deleteRecipeThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.deleteSuccess = false;
      })
      .addCase(deleteRecipeThunk.fulfilled, (state) => {
        state.loading = false;
        state.deleteSuccess = true;
        state.error = null;
      })
      .addCase(deleteRecipeThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetRecipeState } = recipeSlice.actions;
export default recipeSlice.reducer;
